<template>
  <b-container class="icons-section w-100">
    <b-row>
      <b-col sm="12" md="6" class="container-description d-flex align-items-strech">
        <Icon
          icon="safe-payment"
          :stroke="false"
          :height="iconSize"
          :width="iconSize"
          :color="getExperienceColor"
          class="svg-container"
        />
        <div class="content">
          <h3 class="title">{{ $t(`${plansPage}.${getExperience}.iconBlock.bigIconTitle1`) }}</h3>
          <p>{{ $t(`${plansPage}.${getExperience}.iconBlock.bigIconDescription1`) }}</p>
        </div>
      </b-col>
      <b-col md="6" class="container-description d-flex align-items-strech">
        <Icon
          icon="refund"
          :stroke="false"
          :height="iconSize"
          :width="iconSize"
          :color="getExperienceColor"
          class="svg-container"
        />
        <div class="content">
          <h3 class="title">{{ $t(`${plansPage}.${getExperience}.iconBlock.bigIconTitle2`) }}</h3>
          <p>
            {{ $t(`${plansPage}.${getExperience}.iconBlock.bigIconDescription2`) }}
          </p>
        </div>
      </b-col>
    </b-row>
    <div class="w-100">
      <h2 class="title">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconsTitle`) }}</h2>
      <div class="icons-subscription d-flex align-items-strech justify-content-center">
        <div class="icons-container">
          <Icon
            icon="tshirt-mockup"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText1`) }}</h3>
        </div>
        <div class="icons-container">
          <Icon
            icon="license"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText2`) }}</h3>
        </div>
        <div class="icons-container">
          <Icon
            icon="download-different-formats"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText3`) }}</h3>
        </div>
        <div class="icons-container">
          <Icon
            icon="license"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText4`) }}</h3>
        </div>
        <div class="icons-container">
          <Icon
            icon="new-content-daily"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText5`) }}</h3>
        </div>
      </div>
    </div>
    <div class="w-100">
      <h2 class="title">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconsTitle2`) }}</h2>
      <div class="icons-subscription d-flex align-items-strech justify-content-center">
        <div class="icons-container">
          <Icon
            icon="fully-editable"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText6`) }}</h3>
        </div>
        <div class="icons-container">
          <Icon
            icon="scalable-size"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText7`) }}</h3>
        </div>
        <div class="icons-container">
          <Icon
            icon="premium-support"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText8`) }}</h3>
        </div>
        <div class="icons-container">
          <Icon
            icon="professional-designers"
            :stroke="false"
            :height="iconSize"
            :width="iconSize"
            :color="getExperienceColor"
          />
          <h3 class="text-icon">{{ $t(`${plansPage}.${getExperience}.iconBlock.iconText9`) }}</h3>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from 'UI/Icon';

export default {
  name: 'IconBlock',
  components: {
    Icon
  },
  props: {
    lifetime: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      iconSize: 55
    };
  },
  computed: {
    ...mapGetters('experience', ['getExperience', 'getExperienceColor']),
    plansPage() {
      return this.lifetime ? 'lifetimePlans' : 'plans';
    }
  }
};
</script>

<style lang="scss" scoped>
.container-description {
  @include md {
    flex-direction: column;
    margin-bottom: 20px;
    .svg-container {
      margin: 0 auto 20px auto;
    }
  }
}
.content {
  padding: 10px;
  margin-left: 40px;
  .title {
    color: $strongGray;
    font-size: 22px;
    text-align: left;
    margin-bottom: 15px;
  }
  p {
    font-size: 15px;
    color: $strongGray;
    font-weight: 500;
    line-height: 20px;
  }
  @include sm {
    margin-left: 0;
  }
}
.icons-section {
  display: grid;
}
.icons-section > div {
  margin-top: 100px;
  margin-bottom: 100px;
}
.title {
  color: $strongGray;
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 70px;
}
.icons-subscription {
  flex-flow: wrap;
}
.icons-container {
  width: 16%;
  margin: 20px 2%;
  padding: 0 5px;
  text-align: center;
  @include lg {
    width: 29.33%;
  }
  @include sm {
    width: 46%;
  }
  .text-icon {
    font-size: 15px;
    color: $strongGray;
    font-weight: 500;
    margin-top: 10px;
    line-height: 20px;
  }
}
</style>
